import { render, staticRenderFns } from "./PantonePage.vue?vue&type=template&id=3f5691dd"
import script from "./PantonePage.js?vue&type=script&lang=js&external"
export * from "./PantonePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports